// extracted by mini-css-extract-plugin
export default {"internalContent":"mimic___styles_internalContent__uoeaC","multipleMonth":"mimic___styles_multipleMonth__8ATbW"};